module.exports = __webpack_public_path__ + "img/map-pin.b2f804bd.svg";